'use strict';

var React = require('react'),
    _ = require('underscore'),
    FormMixin = require('../mixins/FormMixin'),
    Button = require('../atoms/Button'),
    BtnGroup = require('../molecules/BtnGroup'),
    Icon = require('../atoms/Icon'),
    Link = require('../atoms/Link'),
    FormInputRow = require('../molecules/FormInputRow'),
    Analytics = require('../utils/Analytics'),
    IframeForm = require('../molecules/IframeForm'),
    validateEmail = require('../utils/validateEmail'),
    UserActionCreators = require('../actions/UserActionCreators'),
    FormMessage = require('./FormMessage'),
    FormStore = require('../stores/FormStore'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    config = require('config'),
    { PropTypes } = React;

require('./Login.less');

var Login = React.createClass({
  mixins: [FormMixin, PureRenderMixin],

  propTypes: {
    allowClose: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    onSignupClick: PropTypes.func.isRequired,
    onResetPasswordClick: PropTypes.func.isRequired,
    endpoints: PropTypes.array.isRequired
  },

  getInitialState: function () {
    return {
      email: FormStore.getDefaultValue('email') || '',
      password: FormStore.getDefaultValue('password') || ''
    };
  },

  render: function () {
    var emailCredentials = (
      <IframeForm ref='loginForm' name='login' action='/login'>
        <FormInputRow type='email'
                      name='email'
                      ref='email'
                      formLink={this.linkValidatedState('email', validateEmail)}
                      label='Email'
                      onKeyUp={this.handleKeyUp}
                      autofill />

        <FormInputRow type='password'
                      name='password'
                      ref='password'
                      formLink={this.linkValidatedState('password', this.validatePassword)}
                      label='Password'
                      onKeyUp={this.handleKeyUp}
                      autofill />
      </IframeForm>
    );

    return (
      <div className='Modal-body'>
        <div className='Modal-header'>
          <h3 className='Modal-title'>
            Log In
          </h3>
          {this.props.allowClose &&
            <div onTouchTap={this.props.onCloseClick} className='Modal-close'>
              <Icon name='cross' size='small' mode='stroke' />
            </div>
          }
        </div>

        <div className='Modal-content'>
          <div className='Modal-error'>
            {this.renderErrors()}
          </div>
          <div className='Login-services'>
            <BtnGroup vertical>
              {this.renderButtons()}
            </BtnGroup>
            <div className='Login-or utils--smallCaps'>or</div>
          </div>
           {emailCredentials}
        </div>

        <div className='Modal-footer'>
          <Button size='large'
                  color='green'
                  onClick={this.submitForm.bind(this, this.sendRequest)}
                  disabled={!this.isFormEditable()}>
            Log In
          </Button>

          <div className='Modal-footerText'>
            {config.signUpEnabled &&
            <span>
              Don’t have an account?
              {' '}
              <Link onClick={this.props.onSignupClick}
                    color='green'
                    bold>
                Sign Up
              </Link>
              {'.'}
            </span>}
          </div>
        </div>
      </div>
    );
  },

  handleKeyUp: function (e) {
    if (!this.isEnterKey(e)) {
      return;
    }

    if (!this.state.email) {
      this.refs.email.focus();
    } else if (!this.state.password) {
      this.refs.password.focus();
    }

    this.submitForm(this.sendRequest);
  },

  renderButtons: function () {
    return _.map(this.props.endpoints, function (endpoint) {
      return (
        <Button key={endpoint.id}
                href={endpoint.url}
                color={endpoint.id.toLowerCase()}
                onClick={this.handleLoginClick.bind(this, endpoint.id)}
                size='large'
                fullWidth>
          <Icon name={endpoint.id.toLowerCase()} size='small' />
          {'Log In with ' + endpoint.title}
        </Button>
      );
    }.bind(this));
  },

  renderErrors: function () {
    return _.map(this.props.endpoints, function (endpoint) {
      return (
        <FormMessage key={endpoint.id}
                     formLink={this.linkState(endpoint.id.toLowerCase())} />
      );
    }.bind(this));
  },

  handleLoginClick: function (serviceType) {
    UserActionCreators.loginWithServiceAccount(serviceType);
  },

  validatePassword: function (password) {
    var permanentHelp = <Link color='gray' onClick={this.props.onResetPasswordClick}>Forgot your password?</Link>;
    password = (password || '').trim();

    if (!password) {
      return {
        permanentHelp: permanentHelp,
        error: 'Required'
      };
    }

    return {
      permanentHelp: permanentHelp
    };
  },

  sendRequest: function () {
    Analytics.trackEvent('forms.login.send', _.pick(this.state, 'email'));
    this.refs.loginForm.submit();
  }
});

module.exports = Login;



/** WEBPACK FOOTER **
 ** ./modals/Login.jsx
 **/